import { css } from '@emotion/core';
import postTemplate from './postTemplate';

const templates = css`
  ${postTemplate}
`;

export default templates;
